import { ContentPageSortField } from '@xing-com/crate-common-graphql-types';

export type NewsSourcesSortingItems = Exclude<
  ContentPageSortField,
  ContentPageSortField.DateFollowed
>;

export const SORTING_ITEMS: NewsSourcesSortingItems[] = [
  ContentPageSortField.CreatedAt,
  ContentPageSortField.Title,
  ContentPageSortField.PageFollowsCount,
];

export const INITIAL_SORTING_ITEM = SORTING_ITEMS[0];

export const sortingOptionToCopyKeyMap: Record<
  NewsSourcesSortingItems,
  string
> = {
  [ContentPageSortField.Title]: 'FOLLOWING_RECOMMENDATION_PAGE_SORTING_A_Z',
  [ContentPageSortField.CreatedAt]:
    'FOLLOWING_RECOMMENDATION_PAGE_SORTING_NEWEST',
  [ContentPageSortField.PageFollowsCount]:
    'FOLLOWING_RECOMMENDATION_PAGE_SORTING_MOST_POPULAR',
};
